// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useState } from 'react';
import { func, oneOfType, object, arrayOf } from 'prop-types';

import FilterGroupComponent from 'Components/Filters/FilterGroup';
import { FilterPropType, FilterValuesPropType } from 'Types/filters';

const FilterGroup = ({ filter, onChange, activeFilter }) => {
  const [open, setOpen] = useState(true);
  const handleOnToggle = () => setOpen(!open);
  const [search, setSearch] = useState('');
  const [filterValues, setFilterValues] = useState(filter.values);
  const handleOnSearch = evt => {
    const { value } = evt.target;
    if (value) {
      setSearch(value.trim());
    } else if (search) {
      setSearch('');
    }
  };
  const defaultChecked = useCallback(
    id => {
      if (!activeFilter) {
        return false;
      }
      if (Array.isArray(activeFilter)) {
        return activeFilter.findIndex(i => i.valueId === id) !== -1;
      }
      return Object.values(activeFilter).findIndex(i => i.valueId === id) !== -1;
    },
    [activeFilter]
  );

  useEffect(() => {
    if (search) {
      const normalizedSearch = search.toLowerCase();
      setFilterValues(filter.values.filter(item => (
        String(item.value).toLowerCase().includes(normalizedSearch)
      )));
    } else {
      setFilterValues(filter.values);
    }
  }, [search]);

  useEffect(() => {
    setSearch('');
    setFilterValues(filter.values);
  }, [filter]);

  return (
    <FilterGroupComponent
      open={ open }
      onToggle={ handleOnToggle }
      setOpen={ setOpen }
      filter={ filter }
      filterValues={ filterValues }
      onChange={ onChange }
      activeFilter={ activeFilter }
      defaultChecked={ defaultChecked }
      onSearch={ handleOnSearch }
    />
  );
};

FilterGroup.propTypes = {
  onChange: func,
  activeFilter: oneOfType([object, arrayOf(FilterValuesPropType)]),
  filter: FilterPropType,
};

export default FilterGroup;
